<template lang="pug">
  v-app
    router-view(:key="$route.path")

    Notification(v-for="n in $store.state.notification.list" :key="n.id" :value="n")
</template>

<style lang="stylus">
  // アプリ全体の印刷ポリシー。画面固有のレイアウトは各画面（view）側に置く。
  @media print
    // 画面用に外部サービスが body に差し込むウィジェット（Zendesk のヘルプ/チャット）は
    // 紙に載せない。ベンダの JS API（zE の hide）で消す方式は、実際の非表示化が
    // ベンダ側の非同期処理に委ねられ、印刷レイアウトの確定に間に合う保証がない
    // （Windows Chrome で実際に印刷物へ残った）。@media print は印刷レイアウト確定時には
    // 必ず適用済みなので、タイミングに依存しない。
    // ウィジェットの id / title はベンダ仕様や UI 言語（ja/en/pt）で変わるため当てにせず、
    // 「アプリ内に紙へ出したい iframe は存在しない」という事実に基づいて iframe を一律で隠す。
    // 印刷したい iframe を将来埋め込む場合は、このルールの見直しが必要。
    iframe
      display none !important

    // 画面用の地色（#F3F6F7）は紙では使わない。html は public/index.html の
    // インライン <style>、#app は下の #app ルールで指定している。
    // html の背景はページ全体（余白を含むキャンバス）へ伝播し、#app は Vuetify の
    // .application--wrap { min-height: 100vh } により最終ページのコンテンツ下端より
    // 下まで伸びるため、両方を白にしないと最終ページ下部と各ページの余白が
    // 灰色で印刷される。ページの地色は個々の画面の scoped style からは届かない
    // （html / #app は view の外側の祖先）ので、アプリ共通のポリシーとしてここに置く。
    html, #app
      background-color #fff !important

  html
    overflow-y auto !important

  #app
    background-color #F3F6F7
    color #707070

  .pointer
    cursor pointer

  .cursor-default
    cursor default

  .ellipsis
    text-overflow ellipsis
    overflow hidden
    white-space nowrap

  .align-end
    align-items flex-end !important

  .pre
    white-space pre-wrap

  .flex-grow-0
    flex-grow 0 !important

  .flex-column
    flex-direction column
</style>

<script>
import Notification from "@/components/Notification"

export default {
  components: {
    Notification,
  },
}
</script>
